import { RenaultDistributorDTO } from "./renault-distributor";
import { RenaultFileDTO } from "./renault-file-dto";
import { DistributorParams } from "./shared-dto";

export class RenaultLocalCampaignOrderDTO {
  IdOrder: string | null;
  IdPvGroup: number;
  IdCampaign: string;
  IdContactList: number | null;
  DesiredDate: Date | null;
  SendDate: Date | null;
  Subject: string;
  Data: string;
  HasOrderData: boolean;
  HasOrderValidation: boolean;
  TimedOutContactList: boolean;
  ContactListTimedOutDate: any;
  DeclinedReason: string;
}

export class RenaultLocalCampaignOrderPostDTO {
  IdOrder: string | null;
  IdCampaign: string;
  IdContactList: number | null;
  DesiredDate: Date | null;
  SendDate: Date | null;
  Subject: string;
  Data: string;
  BbddFormFile: File;
  Conditions: boolean;
}

export interface RenaultLocalCampaignOrderSendTestDTO {
  IdCampaign: string;
  Subject: string;
  Contact: string;
  FormData: string;
}

export interface RenaultLocalCampaignOrderListDTO {
  IdOrder: string;
  IdOrderInt: number[];
  IdCampaignMedia: number;
  IdBrand: number;
  Brand: number;
  IdStatus: number;
  Status: string;
  Distributor: RenaultDistributorDTO[];
  DistributorsOrder: RenaultDistributorDTO[];
  PvGroup: string;
  CampaignTitle: string;
  ContactListName: string;
  CampaignImageFile: RenaultFileDTO | null;
  CampaignArgumentativeFile: RenaultFileDTO | null;
  CampaignOffersFile: RenaultFileDTO | null;
  SendDate: Date | null;
  DesiredDate: Date | null;
  HasOrderValidation: boolean;
  FreeTitle: string;
}

export class RenaultLocalCampaignOrderListFilterDTO {
  IdBrand: number = 0;
  IdCampaignMedia: number;
  IdCampaign: number = 0;
  IdStatus: number = 0;
  Page: number = 0;
  ItemsByPage: number;
  DistributorFilters: DistributorParams = new DistributorParams();
}

export interface RenaultLocalCampaignOrderStatisticsDTO {
  IdOrder: string;
  IdOrderInt: number[];
  IdStatus: number;
  Status: string;
  Brand: string;
  PvGroup: string;
  CampaignTitle: string;
  ContactListName: string;
  CampaignImageFile: RenaultFileDTO | null;
  SendDate: Date | null;
  CampaignEndDate: Date | null;
}

export class LocalCampaignOrderDataStatisticsModel {
  Status: LocalCampaignOrderDataStatisticsStatusModel[];
  Abiertos: number;
  Clicks: number;
  ClicksTotales: number;
  TotalBbdd: number;
  OptOut: number;
  VisitaTaller: number;
  Facturacion: number;
}

export class LocalCampaignOrderDataStatisticsStatusModel {
  IdStatus: number;
  Contador: number;
}

export class LocalCampaignOrderDataStatisticsTimechartModel {
  CreationDate: Date;
  IdLogType: number;
  Contador: number;
}

export class LocalCampaignEmailStatisticsModel {
  TotalSentCampaigns: number;
  TotalBBDD: number;
  SuccessPerc: number;
  Success: number;
  Open: number;
  OpenPerc: number;
  Clicks: number;
  ClicksPerc: number;
  Reactivity: number;
  ReactivityPerc: number;
  OptOut: number;
  OptOutPerc: number;
  VisitaTaller: number;
  VisitaTallerPerc: number;
  Facturacion: number;
  FacturacionMedia: number;
  ChartTotalBbdd: number[];
  ChartSuccess: number[];
  ChartOpen: number[];
  ChartClicks: number[];
  ChartVisits: number[];
  ChartMonths: string[];
}

export class LocalCampaignSmsStatisticsModel {
  TotalSentCampaigns: number;
  TotalBBDD: number;
  SuccessPerc: number;
  Success: number;
  VisitaTaller: number;
  VisitaTallerPerc: number;
  Facturacion: number;
  FacturacionMedia: number;
  ChartTotalBbdd: number[];
  ChartSuccess: number[];
  ChartMonths: string[];
}

export class LocalCampaignMediaStatisticsFilters {
  DistributorFilters: DistributorParams;
  Year: number;
}

export class LocalCampaignEmailStatisticsTable {
  Campaign: string;
  TotalBBDD: string;
  SuccessPerc: number;
  Success: string;
  RebotePerc: number;
  Rebote: string;
  Open: string;
  OpenPerc: number;
  Clicks: string;
  ClicksPerc: number;
  Reactivity: string;
  ReactivityPerc: number;
  OptOut: number;
  OptOutPerc: number;
  VisitaTaller: number;
  VisitaTallerPerc: number;
  Facturacion: number;
  FacturacionMedia: number;
  Options: LocalCampaignMediaStatisticsTableOptions

}

export class LocalCampaignSmsStatisticsTable {
  Campaign: string;
  TotalBBDD: string;
  SuccessPerc: number;
  Success: string;
  RebotePerc: number;
  Rebote: string;
  VisitaTaller: number;
  VisitaTallerPerc: number;
  Facturacion: number;
  FacturacionMedia: number;
  Options: LocalCampaignMediaStatisticsTableOptions

}

export class LocalCampaignMediaStatisticsTableOptions {
  IdOrders: number[];
  IdCampaign: string;
}
export class LocalCampaignSmsCostModel {
  Month: string;
  Total: number;
  Amount: string;
}



export class LocalCampaignOrderValidationFilter {
  DistributorFilters: DistributorParams;
  IdStatus: number;
  IdBrand: number;
  Year: number;
}

